import { applyMiddleware, createStore } from "@reduxjs/toolkit";
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from "redux-saga"
import reducers from "./reducers";
import rootSaga from "./sagas/rootSaga";
const sagaMiddleware = createSagaMiddleware()
export const store = createStore(
    reducers,
    composeWithDevTools(applyMiddleware(sagaMiddleware))
);
sagaMiddleware.run(rootSaga)